// Function to open Gorgias chat widget
function openGorgiasChat() {
  // Method 1: Using Gorgias API (most reliable)
  if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
    window.GorgiasChat.open();
  }
  // Method 2: Alternative API call
  else if (window.Gorgias && typeof window.Gorgias.open === 'function') {
    window.Gorgias.open();
  }
  // Method 3: Click the chat widget button (fallback)
  else {
    const chatButton = document.querySelector('[data-gorgias-chat-widget]') || 
                     document.querySelector('.gorgias-chat-widget') ||
                     document.querySelector('#gorgias-chat-widget') ||
                     document.querySelector('[id*="gorgias"]') ||
                     document.querySelector('[class*="gorgias"]');
    
    if (chatButton) {
      chatButton.click();
    } else {
      console.warn('Gorgias chat widget not found');
    }
  }
}

// Wait for Gorgias to load before setting up click handlers
function waitForGorgias(callback) {
  if (window.GorgiasChat || window.Gorgias) {
    callback();
  } else {
    setTimeout(() => waitForGorgias(callback), 500);
  }
}

document.addEventListener("DOMContentLoaded", () => {

waitForGorgias(function() {
    // Add click event to open chat
    const chatElement = document.querySelector('.contact-right em');
    if (chatElement) {
      chatElement.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling
        openGorgiasChat();
      });
    }
});
  
document.querySelector('.new-submit').addEventListener('click', function(event) {
  event.preventDefault(); // Prevent default form submission

  let fname = document.querySelector('#ContactForm-name').value.trim(); // Trim leading/trailing spaces
  let lname = document.querySelector('#ContactForm-last-name').value.trim();
  let email = document.querySelector('#ContactForm-email').value.trim();

  // Clear previous errors and input styling
  document.querySelectorAll('.field__error').forEach(error => {
    error.style.display = 'none';
    let errorMessage = error.querySelector('.error-message');
    if (errorMessage) errorMessage.remove();
  });
  document.querySelectorAll('#ContactForm-email, #ContactForm-name, #ContactForm-last-name').forEach(input => input.classList.remove('input-error'));

  let hasError = false; // Flag to track any error

  // Regular expression to validate email format
  let emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // Helper function to show errors
  function showError(inputSelector, message) {
    let fieldError = document.querySelector(inputSelector).closest('.field').querySelector('.field__error');
    fieldError.style.display = 'flex';
    if (!fieldError.querySelector('.error-message')) {
      let errorMessage = document.createElement('span');
      errorMessage.classList.add('error-message');
      errorMessage.textContent = ` ${message}`;
      fieldError.appendChild(errorMessage);
    }
    document.querySelector(inputSelector).classList.add('input-error');
    hasError = true;
  }

  // Validate first name
  if (fname === '') {
    showError('#ContactForm-name', 'Ce champ est obligatoire.');
  } else if (/\s/.test(fname)) { // Check for spaces
    showError('#ContactForm-name', 'Nom ne peut pas contenir d\'espaces.');
  }

  // Validate last name
  if (lname === '') {
    showError('#ContactForm-last-name', 'Ce champ est obligatoire.');
  } else if (/\s/.test(lname)) { // Check for spaces
    showError('#ContactForm-last-name', 'Nom De Famille Ne peut pas contenir d\'espaces.');
  }

  // Validate email
  if (email === '') {
    showError('#ContactForm-email', 'Ce champ est obligatoire.');
  } else if (!emailPattern.test(email)) {
    showError('#ContactForm-email', 'L\'adresse e-mail n\'est pas valide.');
  }

  // If there are no errors, trigger the form submission
  if (!hasError) {
    document.querySelector('.submit-contact').click(); // Programmatically trigger the submit button
  }
});

  
    const form = document.getElementById('ContactForm');

    form.addEventListener('submit', function(event) {
      let valid = true;
      const requiredFields = form.querySelectorAll('[data-rule*="required"]');

      requiredFields.forEach(function(field) {
        if (!field.value.trim()) {
          valid = false;
          field.closest('.field').classList.add('field--with-error');
          field.setAttribute('aria-invalid', 'true');
        } else {
          field.closest('.field').classList.remove('field--with-error');
          field.removeAttribute('aria-invalid');
        }
      });

      if (!valid) {
        event.preventDefault();
      }
    });

     function updateFieldState(field) {

        if (field.id === 'ContactForm-email' && !validateEmail(field.value)) {
            field.closest('.field').classList.add('field--with-error');
            field.setAttribute('aria-invalid', 'true');
        } else if (!field.value.trim()) {
            field.closest('.field').classList.add('field--with-error');
            field.setAttribute('aria-invalid', 'true');
        } else {
            field.closest('.field').classList.remove('field--with-error');
            field.removeAttribute('aria-invalid');
        }
    }

    // Attach keyup listeners to all required fields for real-time validation
    const requiredFields = form.querySelectorAll('[data-rule*="required"]');
    requiredFields.forEach(function(field) {
        field.addEventListener('keyup', function() {
            updateFieldState(field); // Validate field in real-time
        });
    });


  //Label Color Change on input
  // Function to change the label color based on input field's value
    function updateLabelColor(inputField) {
        const label = inputField.closest('.field').querySelector('.field__label');
        if (inputField.value.trim() !== '') {
            // Change label color when the input field is filled
            label.style.color = '#8589BB'; // Change this to your desired color (e.g., green)
        } else {
            // Reset label color when the input field is empty
            label.style.color = ''; // This will reset to the default color
        }
    }

    // Attach event listeners to all input fields
    const inputFields = document.querySelectorAll('.field input, .field textarea');
    inputFields.forEach(inputField => {
        // Check on 'input' event (as the user types)
        inputField.addEventListener('input', function() {
            updateLabelColor(inputField);
        });

        // Also check on 'blur' event (when the user leaves the input field)
        inputField.addEventListener('blur', function() {
            updateLabelColor(inputField);
        });

        // Initial check in case the field is pre-filled
        updateLabelColor(inputField);
    });



  //Success Pop Up
  const closeButtons = document.querySelectorAll(".btn-close");
  const contactSuccess = document.querySelector(".contact-success");
  const overlay = document.querySelector(".overlay");
  const footerSection = document.querySelector(".footer"); 
  const footerInput = document.querySelector(".footer .newsletter-form__field-wrapper .field"); 
  const footerLabel = document.querySelector(".footer .newsletter-form__privacy-policy"); 
  const bodyElement = document.body;

  if (contactSuccess && overlay) {
    // Show overlay and contact-success
    const showSuccess = () => {
      overlay.style.display = "flex";
      contactSuccess.style.display = "flex";
      bodyElement.style.overflow = "hidden"; 
      footerSection.style.position = "relative";
      footerSection.style.zIndex = -9;      
      footerInput.style.zIndex = -9;
      footerLabel.style.zIndex = -9;
    };

    // Hide overlay and contact-success
    const hideSuccess = () => {
      overlay.style.display = "none";
      contactSuccess.style.display = "none";
      bodyElement.style.overflow = "auto"; 
      footerSection.style.position = "";
      footerSection.style.zIndex = "";      
      footerInput.style.zIndex = "";
      footerLabel.style.zIndex = "";
    };

    // Add click event listeners to all close buttons
    closeButtons.forEach((button) => {
      button.addEventListener("click", hideSuccess);
    });

    // Close the contact success when clicking outside of it (on the overlay)
    overlay.addEventListener("click", (e) => {
      // Ensure the click happened on the overlay, not inside the contact-success
      if (e.target === overlay) {
        hideSuccess();
      }
    });

    // Example: Simulate showing contact-success (remove in production)
    //setTimeout(showSuccess, 1000); // Auto-display for testing
    // Directly show the contact-success upon DOM content load
    showSuccess();
  }
  //end of Success Pop Up

  //Custom Select
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;

  /* create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected select-selected-placeholder");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

  x[i].appendChild(a);

  /* create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 0; j < ll; j++) {
    /* create a new DIV for each option in the original select element: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
      /* When an item is clicked, update the original select box and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          h.innerHTML = this.innerHTML;
          h.style.color = ""; // Remove the red color
          h.classList.remove("select-selected-placeholder");

          // Check if the first option is selected and update the label color
          var label = document.querySelector('.form__label.field__label');
          if (s.options[i].value !== "0") {
            label.style.color = "#8589BB"; // Update label color for valid selection
          } else {
            label.style.color = ""; // Reset label color if placeholder is selected
            h.classList.add("select-selected-placeholder"); // Add the placeholder class again
          }

          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
    /* When the select box is clicked, close any other select boxes and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

/* Function to close all select boxes in the document except the current select box: */
function closeAllSelect(elmnt) {
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i) == -1) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box, close all select boxes: */
document.addEventListener("click", closeAllSelect);

  //end of Custom Select
  
});
